import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TRAINING_FAQS } from "../../data/trainingData";

const TrainingFAQ = () => {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <section
      className="bg-white py-14 md:py-20 px-4 sm:px-6 lg:px-8"
      aria-label="Training frequently asked questions"
      id="training-faq"
    >
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <div
            className="w-20 h-1 bg-[#F86624] mx-auto rounded-full mb-5"
            aria-hidden="true"
          />
          <p className="text-gray-600 text-base md:text-lg">
            Quick answers about our training formats, certificates, and how to
            enrol.
          </p>
        </div>

        <div className="space-y-3">
          {TRAINING_FAQS.map((faq, index) => {
            const open = openFaq === index;
            return (
              <div
                key={faq.q}
                className="bg-gray-50 rounded-2xl border border-gray-100 overflow-hidden shadow-sm"
              >
                <button
                  type="button"
                  onClick={() => setOpenFaq(open ? null : index)}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 md:px-6 md:py-5"
                  aria-expanded={open}
                >
                  <span className="font-semibold text-gray-900 text-sm md:text-base">
                    {faq.q}
                  </span>
                  <motion.span
                    animate={{ rotate: open ? 180 : 0 }}
                    className="text-[var(--bg-primary)] flex-shrink-0"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      aria-hidden="true"
                    >
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                      className="overflow-hidden"
                    >
                      <p className="px-5 pb-5 md:px-6 text-sm text-gray-600 leading-relaxed border-t border-gray-50 pt-3">
                        {faq.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrainingFAQ;
